import { useState, useEffect, useRef } from 'react'

// Hook que sincroniza un estado con localStorage. La key debe ser única por
// pantalla (ej: 'lgr.filtros.nv'). Si la lectura falla o el storage no está
// disponible, cae al `defaultValue` sin romper la app.
export function useStoredState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key)
      if (raw == null) return defaultValue
      const parsed = JSON.parse(raw)
      // Merge con defaults — si agregamos campos nuevos al filtro, no rompe
      // sesiones viejas que tienen JSON sin esa key.
      if (defaultValue && typeof defaultValue === 'object' && !Array.isArray(defaultValue)) {
        return { ...defaultValue, ...parsed }
      }
      return parsed
    } catch {
      return defaultValue
    }
  })

  // Evitar escribir en el primer render (ya leímos el valor inicial de ahí).
  const skipFirst = useRef(true)
  useEffect(() => {
    if (skipFirst.current) { skipFirst.current = false; return }
    try { localStorage.setItem(key, JSON.stringify(value)) } catch { /* ignore */ }
  }, [key, value])

  return [value, setValue]
}
